import React from 'react'
import styled from 'styled-components'
import {NamesListTypes} from "../../../components/analytic/NamesList/NamesList";
import {ChartTypes} from "../../../components/analytic/Chart/Chart";
import {Balance, Block1, Block2, Block3, Block4, Chart, LayoutMobile, NamesList} from "../../../components/analytic";

type LayoutTypes = {
    className?: string;
    chartTypes: ChartTypes;
    readingStart: { checked?: any, onChange?: any, hide?: boolean };
    blocks?: {
        allReading: string | number;
        allErrors: string | number;
        allEarned: string | number;
        minimalTime: any;
        maximumTime: any;
        averageTime: any;
        balance: any;
    };
    list: NamesListTypes;
    loading: any
};

function StatisticMobile(props: LayoutTypes) {
    return (
        <StyledLayout className={props.className}>
            <LayoutMobile>
                {
                    props?.blocks?.balance === false ? ""  : <Balance
                        className={'balance layout-option'}
                        mainText={props?.blocks?.balance}
                        subText={'Баланс'}/>
                }
                <Block1 loading={props.loading} title={'Заработано'}
                        className={'testResult layout-option'}
                        value={{mainText: props?.blocks?.allEarned || 0, subText: 'руб'}}/>
                {!props?.readingStart?.hide &&
                <Block4
                    loading={props.loading}
                    className={"reading layout-option"}
                    title={"Запуск чтения"}
                    changeHandler={props?.readingStart?.onChange}
                    checked={props?.readingStart?.checked}
                />
                }

                <div className='readingCount'>
                    <Block2
                        loading={props.loading}
                        className={'block layout-option'}
                        title={'Всего описано'}
                        content={{
                            mainText: props?.blocks?.allReading,
                            subText: 'Снимков'
                        }}
                    />

                    <Block2
                        loading={props.loading}
                        className={'block layout-option'}
                        title={'Описано онлайн'}
                        content={{mainText: props?.blocks?.allErrors, subText: 'Снимков'}}
                    />
                </div>
                <NamesList {...props.list} title={"Список докторов"} className="namesList layout-option"/>

                <Chart loading={props.loading} className={'chart layout-option'} {...props.chartTypes} />

                <div className='footer layout-option'>
                    <div className='time'>

                        <Block3 loading={props.loading}
                                bg={'pink'}
                                mainText={props?.blocks?.averageTime || 0}
                                subText={'Среднее время'}
                                className={'time-block'}/>

                        <Block3 loading={props.loading} bg={'blue'} mainText={props?.blocks?.minimalTime || 0}
                                subText={'Минимальное время'}
                                className={'time-block'}/>
                        <Block3 loading={props.loading} bg={"lightBlue"}
                                mainText={props?.blocks?.maximumTime || 0}
                                subText={"Максимальное время"}
                                className={'time-block'}/>
                    </div>
                </div>
            </LayoutMobile>

        </StyledLayout>
    )
}

const StyledLayout = styled.div`
  display: flex;
  width: 100%;
  height: max-content;
  flex-direction: column;
  align-items: center;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;


  .main {
    height: 100%;
    width: 95%;
    display: flex;
    flex-direction: column;
    z-index: 2;

    .testResult {
      width: 100%;
      flex-direction: column;
      align-items: flex-start;
      box-sizing: border-box;
      justify-content: space-around;
      height: max-content;
      padding-left: 40px;
      padding-top: 20px;
      padding-bottom: 30px;
      max-width: unset;

      .key {
        width: 100%;
        text-align: left;
        margin-bottom: 10px;
        justify-content: flex-start;
      }

      .value {
        width: 100%;
        display: flex;
        justify-content: flex-start;

        b {
          margin: 0;
          margin-right: 15px;
        }
      }
    }

    .balance {
      width: 100%;

      .mainText {
        font-size: 30px
      }

      img {
        width: 75px;
        height: 75px;
      }
    }

    .namesList {
    }

    .reading {
      width: 100%;
      flex-direction: row;
      height: 100px;
      box-sizing: border-box;
      align-items: center;
      display: flex;
      justify-content: space-between;
      margin-top: 0;
      padding-top: 0;

      .title {
        display: flex;
        font-size: 20px;
        align-items: center;
        margin: 0;
      }

      .tumbler {
        margin: 0;
      }
    }

    .readingCount {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .block {
        width: 45%;
        padding-left: 30px;
        padding-right: 30px;
      }
    }

    .namesList {
      width: 100%;
      padding-bottom: 0;
      

      .footer {
        display: flex;
        justify-content: center;
        width: 100%;
        margin-top: 10px;
        min-height: unset;
        margin-top: 10px;
        
        .add {
          cursor: pointer;
          margin-bottom: 10px;
        }
      }
    }

    .chart {
      min-height: 300px;

      .custom-date-input {
        margin-right: 10px;
      }

      .header {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
        margin-top: 20px;
        margin-left: 20px;

        .title {
          margin: 0;
        }

        .sort-bar {
          margin-top: 5px;
          margin-left: 0;

          .option {
            margin-left: 0 !important;
            margin-right: 10px;
            font-weight: bold;
            font-size: 14px;
          }
        }
      }
    }

    .footer {
      display: flex;
      justify-content: flex-start;
      width: 100%;
      overflow: auto;
      min-height: 300px;
      &::-webkit-scrollbar {
        height: 0;
        width: 0;
      }

      .time {
        display: flex;
        height: 100%;
        justify-content: flex-start;

        .time-block {
          margin-right: 15px;
          min-width: 160px;
          max-width: 160px;
          min-height: 160px;
          max-height: 160px;
        }
      }
    }
  }
`

export default StatisticMobile
